import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCreditCardMasterCard = ({
    className = '',
    color = '#979797',
    height = 16,
    opacity = 1,
    title,
    width = 25,
}: Icon) => (
    <AccessibleSVG
        className={`icon-credit-card-mastercard ${className}`}
        height={height}
        opacity={opacity}
        title={title}
        viewBox="0 0 25 16"
        width={width}
    >
        <g fill="none" fillRule="evenodd">
            <rect height="15" rx="2" stroke={color} width="24" x=".5" y=".5" />
            <path
                d="M14.90131 11.667774c1.989214 0 3.601396-1.67183 3.601396-3.734012 0-2.06192-1.612182-3.733762-3.601397-3.733762-.930136 0-1.778062.366068-2.417276.96645C11.757002 5.849297 11.3 6.836294 11.3 7.933763c0 1.097232.457002 2.08423 1.184034 2.767574.639214.60037 1.48714.966438 2.417275.966438z"
                fill={color}
                opacity=".5"
            />
            <path
                d="M10.101308 11.667774c1.989216 0 3.601398-1.67183 3.601398-3.734012 0-2.06192-1.612182-3.733762-3.601398-3.733762-.930134 0-1.77806.366068-2.417274.96645C6.957 5.849297 6.5 6.836294 6.5 7.933763c0 1.097232.457 2.08423 1.184034 2.767574.639214.60037 1.48714.966438 2.417274.966438z"
                fill={color}
            />
        </g>
    </AccessibleSVG>
);

export default IconCreditCardMasterCard;
